import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { getDetailMissionById } from "../../../../services/RHService/OrdreDeMissionService";
import OrderMissionContract from "../../EmployeePages/MissionOrder/OrderMissionContract";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { useLocation } from "react-router-dom";

const MissionDetails = () => {
  const location = useLocation();
  const idMission = new URLSearchParams(location.search).get("idMission");
  const [missionDetails, setMissionDetails] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseEmployeeList = await getDetailMissionById(idMission);
        console.log("API Response:", responseEmployeeList.data.success);
        setMissionDetails(responseEmployeeList.data.success);
      } catch (error) {
        console.error("Error in fetchData:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    console.log("outside", missionDetails);
  }, [missionDetails]);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-4 col-md-4">
              <h1 className="m-0">Détail d'ordre de mission</h1>
            </div>
            <div className="col-sm-8 col-md-8">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/ordreDeMission">Liste des ordres de mission</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/Employeemissionlist">En mission</Link>
                </li>
                <li className="breadcrumb-item active">
                  Détail d'ordre de mission
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Ordre de mission</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div className="col-md-3">
                    <strong className="center">
                      Intitulé d'ordre de mission{" "}
                    </strong>
                    <br></br>
                    {missionDetails ? missionDetails.intitule : ""}
                  </div>
                  <div className="col-md-3">
                    <strong className="center">Personnel</strong>
                    <br></br>
                    {missionDetails
                      ? missionDetails.firstname + " " + missionDetails.lastname
                      : ""}{" "}
                  </div>

                  <div className="col-md-3">
                    <strong className="center">Email</strong>
                    <br></br>
                    {missionDetails ? missionDetails.email : ""}
                  </div>
                  <div className="col-md-3">
                    <strong className="center">Envoyer par</strong>
                    <br></br>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Départ - Destination</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div className="col-md-4">
                    <strong className="center">Ville départ </strong>
                    <br></br>
                    {missionDetails ? missionDetails.villeDept : ""}
                  </div>
                  <div className="col-md-4">
                    <strong className="center">Ville destination</strong>
                    <br></br>
                    {missionDetails ? missionDetails.villeDest : ""}{" "}
                  </div>

                  <div className="col-md-4">
                    <strong className="center">Pays destination</strong>
                    <br></br>
                    {missionDetails ? missionDetails.paysDest : ""}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Date Départ - Date fin</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  <div className="col-md-3">
                    <strong className="center">Heure départ </strong>
                    <br></br>
                    {missionDetails ? missionDetails.heureDeb : ""}
                  </div>
                  <div className="col-md-3">
                    <strong className="center">Date de départ</strong>
                    <br></br>
                    {missionDetails ? missionDetails.dateDeb : ""}{" "}
                  </div>

                  <div className="col-md-3">
                    <strong className="center">Heure fin</strong>
                    <br></br>
                    {missionDetails ? missionDetails.heureFin : ""}{" "}
                  </div>
                  <div className="col-md-3">
                    <strong className="center">Date fin</strong>
                    <br></br>
                    {missionDetails ? missionDetails.dateFin : ""}{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Liste des charges</h5>
              </div>
              <div class="card-body">
                <div class="row">
                  {missionDetails && missionDetails.charges ? (
                    missionDetails.charges.map((charge, index) => (
                      <div className="col-md-3" key={index}>
                        <strong className="center">{charge.nomCharge}</strong>
                        <br></br>
                        {charge.frais}dt
                      </div>
                    ))
                  ) : (
                    <p>Loading charges...</p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div className="card-header">
                <h5>Description</h5>
              </div>
              <div class="card-body">
                <p>{missionDetails ? missionDetails.desc : ""}</p>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card">
              <div className="card-footer">
                {/* <button
                  type="submit"
                  className="btn btn-danger col-md-3 float-right"
                  style={{ width: "auto", color: "white" }}
                >
                  {missionDetails ? (
                    <PDFDownloadLink
                      document={
                        <OrderMissionContract missionDetail={missionDetails} />
                      }
                      fileName="Contrat.pdf"
                    >
                      {({ blob, url, loading, error }) =>
                        loading ? "Loading document..." : "Télécharger"
                      }
                    </PDFDownloadLink>
                  ) : (
                    <p>Loading PDF link...</p>
                  )}
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MissionDetails;
